<div class="modal-header">
  <div class="modal-title">
    <h3 class="mb-0">Add bid files</h3>
    @if (title) {
      <p class="modal-subtitle mb-0">{{ title }}</p>
    }
  </div>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="close()"
  ></button>
</div>

<div class="modal-body">
  <p class="upload-helper mb-1">
    Acceptable file types: Image, PDF, Word, and Excel.
  </p>
  <p
    class="upload-helper mb-3"
    [ngClass]="{ 'text-danger': fileErrors['isFileTooBig'] }"
  >
    Maximum file size: 10MB per file, 25MB total.
  </p>

  <app-file-upload-file-display
    [layout]="'vertical'"
    [removeFileButtonText]="'Remove'"
    [Files]="Files"
    [hideSelectFileButton]="true"
    (FileEvent)="fileUpload($event)"
    (removeFileEvent)="removeProposalRequestFile($event)"
  >
  </app-file-upload-file-display>
</div>

<div class="modal-footer">
  <div class="action-row justify-end w-100">
    <button type="button" class="btn btn-ghost" (click)="close()">
      Cancel
    </button>
    <button type="button" class="btn btn-primary" (click)="save()">Save</button>
  </div>
</div>
